const REP_ALIASES = new Set([
  "you",
  "rep",
  "sales rep",
  "sales representative",
  "agent",
  "seller",
  "account manager",
]);

const CLIENT_ALIASES = new Set([
  "client",
  "customer",
  "prospect",
  "buyer",
]);

function normalizedSpeaker(value) {
  return String(value || "").trim().toLowerCase();
}

function matchesStructuredRoleLabel(normalized, aliases) {
  return [...aliases].some((alias) => {
    if (normalized === alias) return true;
    if (!normalized.startsWith(`${alias} `)) return false;

    const suffix = normalized.slice(alias.length).trim();
    return /^\d+(?:\s*[—–-]\s*.+)?$/.test(suffix)
      || /^[—–-]\s*.+$/.test(suffix);
  });
}

export function transcriptSpeakerPresentation(speaker) {
  const normalized = normalizedSpeaker(speaker);

  if (matchesStructuredRoleLabel(normalized, REP_ALIASES) || /^(?:speaker\s*)?a$/.test(normalized)) {
    return { label: "You", toneClass: "is-rep", role: "rep" };
  }

  if (matchesStructuredRoleLabel(normalized, CLIENT_ALIASES) || /^(?:speaker\s*)?b$/.test(normalized)) {
    return { label: "Client", toneClass: "is-client", role: "client" };
  }

  return {
    label: String(speaker || "Speaker").trim() || "Speaker",
    toneClass: "",
    role: "unknown",
  };
}

export function formatPlainTranscriptSpeakers(transcript) {
  if (typeof transcript !== "string") return transcript;

  return transcript
    .replace(/^(?:rep|sales rep|sales representative|agent|speaker\s*a)\s*:/gim, "You:")
    .replace(/^(?:client|customer|prospect|speaker\s*b)\s*:/gim, "Client:");
}
